import React, { useState, useContext } from 'react';
import { Alert, TextField, Button, Typography, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { login } from '../../services/admin';
import { UserContext } from '../../context/UserProvider.jsx';
import './login.css';

const LoginPage = () => {
  const { setToken, setUserType, setAccess } = useContext(UserContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (event) => {
    event.preventDefault();
    if (busy) return;
    setError('');
    setBusy(true);
    try {
      const res = await login({ email: email.trim(), password });
      if (res?.['access-token']) {
        setToken(res['access-token']);
        setUserType(res['user-type']);
        setAccess(res['user-access']);
      } else {
        setError('Unable to sign in. Check your email and password and try again.');
      }
    } catch {
      setError('Unable to connect. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="portal-login">
      <section className="portal-login-card" aria-labelledby="login-title">
        <div className="portal-login-brand"><img src="/logo.png" alt="Store2Door Direct and Restaurant Depot" /></div>
        <header className="portal-login-heading">
          <Typography component="h1" id="login-title">Welcome back</Typography>
          <p>Sign in to your Store2Door account.</p>
        </header>
        <form className="portal-login-form" onSubmit={handleLogin} aria-busy={busy}>
          <TextField id="login-email" name="email" label="Email address" variant="outlined" fullWidth type="email" autoComplete="username" required
            value={email} onChange={event => setEmail(event.target.value)} />
          <TextField id="login-password" name="password" label="Password" variant="outlined" type={showPassword ? 'text' : 'password'} autoComplete="current-password" fullWidth required
            value={password} onChange={event => setPassword(event.target.value)}
            InputProps={{ endAdornment: <InputAdornment position="end"><IconButton type="button" aria-label={showPassword ? 'Hide password' : 'Show password'} onClick={() => setShowPassword(value => !value)} edge="end" sx={{ width: 44, height: 44 }}>{showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}</IconButton></InputAdornment> }} />
          {error && <Alert severity="error">{error}</Alert>}
          <Button type="submit" variant="contained" disableElevation fullWidth disabled={busy} endIcon={busy ? <CircularProgress size={18} color="inherit" /> : <ArrowForwardIcon />}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
        {process.env.REACT_APP_FR_STORE && <footer className="portal-login-location">{process.env.REACT_APP_FR_STORE}</footer>}
      </section>
      <p className="portal-login-caption">Your products. Your orders. All in one place.</p>
    </main>
  );
};

export default LoginPage;
